// Global Enums
import {
  SocketEventType,
} from 'common.enums';

// Services
import MixpanelService from '@vroskus/library-mixpanel/dist/browser';
import CookiesService from '@vroskus/library-cookies/dist/browser';
import SocketService from '@vroskus/library-socket/dist/browser';
import NavigationService from '@vroskus/library-navigation';
import CrispService from '@vroskus/library-crisp';

// Mock services
import ApiServiceMock from './ApiServiceMock';
import TrackerServiceMock from './TrackerServiceMock';
import LocalStorageMock from './LocalStorageServiceMock';

// Types
import type {
  $Services,
} from '..';

const services = (): $Services => {
  const initialisedServices = {
    Api: new ApiServiceMock({
      apiUrl: '',
      timeout: 0,
    }),
    Cookies: new CookiesService(),
    Crisp: new CrispService({
      websiteId: '',
    }),
    LocalStorage: localStorage || new LocalStorageMock(),
    Mixpanel: new MixpanelService({
      token: '',
    }),
    Navigation: NavigationService,
    Socket: new SocketService(
      {
        host: '',
      },
      SocketEventType,
    ),
    Tracker: new TrackerServiceMock({
      apiUrl: '',
      timeout: 0,
    }),
  };

  if (window) {
    window.Services = initialisedServices;
  }

  return initialisedServices;
};

export default services;
